module.exports = __webpack_public_path__ + "img/practice-1.fcd27283.jpg";